(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('BlockedPhoneDialogController', BlockedPhoneDialogController);

    BlockedPhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BlockedPhone', 'PhoneCallResult', 'User', 'Employee'];

    function BlockedPhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BlockedPhone, PhoneCallResult, User, Employee) {
        var vm = this;

        vm.blockedPhone = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.phonecallresults = PhoneCallResult.query();
        vm.users = User.query();
        vm.employees = Employee.query();
        vm.showAllParams = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blockedPhone.id !== null) {
                BlockedPhone.update(vm.blockedPhone, onSaveSuccess, onSaveError);
            } else {
                BlockedPhone.save(vm.blockedPhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:blockedPhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastCallTime = false;
        vm.datePickerOpenStatus.blockingTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
